import React, { useEffect } from "react";

function UploadProgressBar({
  loaded = 0,
  totalToUpload = 0,
  forCopyright,
  customProgress,
}) {
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const checkedTotal = totalToUpload < loaded ? loaded : totalToUpload;
    let total = !forCopyright
      ? checkedTotal
      : checkedTotal + checkedTotal * 0.35;
    const updatedProgress = Math.round((loaded * 100) / total);
    console.log("valuesForProgressBar", loaded, total);
    setProgress(updatedProgress || 0);
  }, [loaded, totalToUpload]);

  useEffect(() => {
    console.log("ProgressBar", progress + "%");
  }, [progress]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "10px",
        overflow: "hidden",
        zIndex: 500,
      }}
    >
      <div
        style={{
          width: `${customProgress || progress}%`,
          position: "absolute",
          left: 0,
          height: "10px",
          background: "#f17b2e",
          transition: "all 250ms",
        }}
      ></div>
    </div>
  );
}

export default UploadProgressBar;
